export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/PolygonRelation.worker.10eaf795.worker.js");
}
